// PRO+ hub hero extras: the PRO+ chip, more social links and the jump-to-section row.
import { Disc, Disc3, Facebook, Youtube } from "lucide-react";

export const ProPlusChip = () => (
  <span className="rounded-full border border-[#54E3FF]/60 px-2 py-0.5 text-[9px] font-black tracking-[0.2em] text-[#54E3FF] shadow-[0_0_14px_rgba(84,227,255,0.35)]" data-testid="hub-pro-plus-chip">PRO+</span>
);

const PILL = "inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 px-3 py-2 rounded-full text-sm no-underline text-white transition-colors";

export const HubSocialPills = ({ band }) => (
  <>
    {band.facebook && <a href={band.facebook} target="_blank" rel="noopener noreferrer" className={PILL} data-testid="hub-facebook"><Facebook className="h-4 w-4" /> Facebook</a>}
    {band.bandcamp && <a href={band.bandcamp} target="_blank" rel="noopener noreferrer" className={PILL} data-testid="hub-bandcamp"><Disc3 className="h-4 w-4" /> Bandcamp</a>}
    {band.youtube && <a href={band.youtube} target="_blank" rel="noopener noreferrer" className={PILL} data-testid="hub-youtube"><Youtube className="h-4 w-4" /> YouTube</a>}
    {band.discogs && <a href={band.discogs} target="_blank" rel="noopener noreferrer" className={PILL} data-testid="hub-discogs"><Disc className="h-4 w-4" /> Discogs</a>}
  </>
);

export const HubNav = ({ band, hasPhotos }) => {
  const hub = band.hub || {};
  const links = [
    ["shows", "Shows", true],
    ["about", "About", band.bio || (band.members || []).length || (band.discography || []).length],
    ["watch", "Watch", (hub.videos || []).length],
    ["press", "Press", (hub.press || []).length],
    ["book", "Book", hub.booking_note || hub.booking_email || band.instagram || band.facebook],
    ["photos", "Photos", hasPhotos],
  ].filter((l) => l[2]);
  return (
    <nav className="flex flex-wrap gap-x-5 gap-y-2 border-t border-[#54E3FF]/20 pt-4" aria-label="On this page" data-testid="hub-nav">
      {links.map(([id, label]) => (
        <a key={id} href={`#${id}`} className="text-xs font-black uppercase tracking-[0.25em] text-white/60 hover:text-[#54E3FF] no-underline transition-colors" data-testid={`hub-nav-${id}`}>{label}</a>
      ))}
    </nav>
  );
};
